import { render } from "./ImageGridShell.vue?vue&type=template&id=0b8b911e&scoped=true"
import script from "./ImageGridShell.vue?vue&type=script&lang=js"
export * from "./ImageGridShell.vue?vue&type=script&lang=js"

import "./ImageGridShell.vue?vue&type=style&index=0&id=0b8b911e&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8b911e"]])

export default __exports__